
/* injects from baggage-loader */

'use strict';

import IssuerOnboardingRecordsComponent from './issuer-onboarding.records.component';

const IssuerOnboardingRecordsPageModule = angular.module('issuer-onboarding-records-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('issuer-onboarding.records', {
        url: '/records',
        title: 'Issuer Onboarding: Records Explaination',
        localTitle: 'Records Explaination',
        component: 'issuerOnboardingRecords',
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('issuerOnboardingRecords', new IssuerOnboardingRecordsComponent());

export default IssuerOnboardingRecordsPageModule;
